export interface TeamMember {
    name: string;
    title: string;
    bio: string;
    imagePlaceholder: string;
    id: string;
    category: 'partner' | 'intern' | 'advisor';
    isHidden?: boolean;
    isArchived?: boolean;
    linkedin?: string;
}

export const teamMembers: TeamMember[] = [
    {
        name: "Amanda Singh, CFA, CMA",
        title: "Fund Operations & Compliance",
        bio: "Former CFO at hedgefund, prev Head of Compliance & Accounting at RIA and roboadvisor. Holds joint honors Bachelor of Science in Molecular Biology and Biochemistry and Business Administration from Simon Fraser University.",
        imagePlaceholder: "Amanda",
        id: "amanda",
        category: "partner",
        isHidden: true
    },
    {
        name: "Rushil Saini",
        title: "Investor Relations and Fundraising",
        bio: "Former Quant Fund Ai and Derivatives lead. Studied Economics From the University of California At Berkeley. Research Lead at 28 Delta.",
        imagePlaceholder: "Rushil",
        id: "rushil",
        category: "partner",
        isHidden: false,
        isArchived: true
    },
    {
        name: "Rohan Sontakke",
        title: "Technology Integration & Internal Systems",
        bio: "Former Founding Engineer at Brutus AI (acquired), Researcher at BAIR, and holds a BA in Data Science from UC Berkeley.",
        imagePlaceholder: "Rohan",
        id: "rohan",
        category: "partner",
        isHidden: false,
        isArchived: true
    },
    {
        name: "Carlos Valls Arenas",
        title: "Research and Modeling Lead",
        bio: "Former Financial Analyst. Studied Statistics, Physics and Data Science at University of California, Berkeley and Business at UC3M ",
        imagePlaceholder: "Carlos",
        id: "carlos",
        category: "intern",
        isHidden: false,
        isArchived: true
    },
    {
        name: "Stefano Balboni",
        title: "Operations",
        bio: "Former Business Consultant & Investment Broker. Studied Management and Marketing at University of California, Berkeley And University of Bologna.",
        imagePlaceholder: "Stefano",
        id: "stefano",
        category: "partner",
        isHidden: false,
        isArchived: true
    },
    {
        name: "Armaan Turnow",
        title: "Founding AI Engineer",
        bio: "Software Engineer at Conveyor specializing in document processing and RAG systems. Previously founded and scaled True Smp to 1000+ members, managing an 8-person team. Former Sales Operations Analyst at LeanIX and intern at Datto, where he streamlined 500+ sales opportunities. Started career at Tripadvisor, selected among top interns for location services team. Expertise in Ruby on Rails, full-stack development, and building secure enterprise APIs.",
        imagePlaceholder: "Armaan",
        id: "armaan",
        category: "partner",
        linkedin: "https://www.linkedin.com/in/armaan-tornow-8727b918a"
   
    },
    {
        name: "Ramakant Gupta",
        title: "Operations & Sourcing",
        bio: "Strategic operator with 4+ years of experience in product development and program management. Previously served as Product/Investment Manager at Utopia Homes, where he led cross-functional initiatives and managed a $4M+ real estate portfolio achieving 13.53% net rental yield.",
        imagePlaceholder: "Ramakant",
        id: "ramakant",
        category: "intern",
        linkedin: "https://www.linkedin.com/in/ramakant-gupta"
    },
    {
        name: "Lucca Bemfica",
        title: "Research and Modeling",
        bio: "M&A Off-Cycle Analyst at KPMG Corporate Finance Copenhagen. Currently pursuing BSc Management at University of Bath. Previously served as Senior Investment Analyst at Bath Finance Society and worked on ~DKK 150m EV consumer sell-side mandates.",
        imagePlaceholder: "Lucca",
        id: "lucca",
        category: "intern",
        isHidden: true
    },
    {
        name: "Egor Arutyunyan",
        title: "Research and Modeling",
        bio: "Investment Banking Off-Cycle Analyst at Alantra with Bachelor in Business Administration from Universidad Carlos III de Madrid. Previously worked as Private Equity Analyst at CNEO Partners, conducting quantitative analysis of SMEs and performing DCF valuations. Co-founded Diario La Colmena, a media association focused on online journalism.",
        imagePlaceholder: "Egor",
        id: "egor",
        category: "intern",
        isHidden: true
    },
    {
        name: "Christian Olomofe",
        title: "Research & Modeling",
        bio: "CFA Level 3 candidate pursuing MBA in Finance & Investment at University of San Francisco. Former Investment Banking Analyst at Morgan Capital Securities with 10+ years in corporate finance and financial advisory. Has managed proprietary investment portfolios exceeding $6.6 million and participated in transactions worth over $7.5 billion. Holds multiple certifications including Advanced Financial Modeler and Fellow designations from Nigerian professional institutes.",
        imagePlaceholder: "Christian",
        id: "christian",
        category: "intern",
        isHidden: true
    },
    {
        name: "Monish Bodapti",
        title: "Research & Modeling",
        bio: "Currently pursuing BBA in Finance, Investment, and Banking & Data Science at University of Wisconsin-Madison. Portfolio Analyst at Capital Management Club managing $300,000 fund, Grata Scholars Program participant, and former Engineering Intern at Allis Roller. Previously served as Co-President of Future Business Leaders of America",
        imagePlaceholder: "Monish",
        id: "monish",
        category: "intern",
        isArchived: true,
        linkedin: "https://www.linkedin.com/in/monishbodapati/"
    },
    {
        name: "Shuwen Ding",
        title: "Research & Modeling",
        bio: "Currently enrolled in Cornell University for Cognitive Science, where she researches memory consolidation and learning in the Schaffer-Nishimura Lab. Her work involves piloting a behavioral task for mice to test memory consolidation and learning, as well as conducting a literature review on viral vectors to target mossy cells in the hippocampus. Additionally, she is involved as an analyst in Cornell Hedge Fund, Cayuga Healthcare Consulting, and Cornell Investment Banking Club. Previously, she worked on 1-MHz ultrasonic cleaning of multilayer-dielectric diffraction gratings at the Laboratory for Laser Energetics at University of Rochester.",
        imagePlaceholder: "Shuwen",
        id: "shuwen",
        category: "intern",
        isArchived: true,
        linkedin: "https://www.linkedin.com/in/shuwending/"
    },
    {
        name: "Rinky Pandey, CFA Level 3 Candidate",
        title: "Principal, Investor Relations",
        bio: "Founder of Upward ROI, supporting founders with fundraising materials and investor positioning. Previously contributed to fundraising materials supporting over $150M of fundraised value. Investor Relations Associate at LetsVenture, engaging with 800+ investors on early-stage deals. Former Analyst at She Capital, evaluating 400+ pitch decks and 300+ founder pitches for early-stage investments. Holds a degree from University of Delhi.",
        imagePlaceholder: "Rinky",
        id: "rinky",
        category: "partner",
        linkedin: "https://www.linkedin.com/in/contact-rinky-pandey/"
    },
    {
        name: "Luca Memoli, MBA",
        title: "Principal, Investor Relations",
        bio: "7+ years of M&A, private capital, IPO, and capital markets experience across Europe and the U.S. Executed 20+ M&A transactions end-to-end alongside private equity counterparties and advised 100+ companies across 30+ industries on capital raising, growth strategy, and governance. Former Senior Associate at Euronext leading capital deal origination across 11 regions. Previously M&A Associate at Iniziativa, advancing from analyst to team lead of six. MBA from Hult International Business School.",
        imagePlaceholder: "Luca",
        id: "luca",
        category: "partner",
        linkedin: "https://www.linkedin.com/in/lucamemoli/"
    },
    {
        name: "Oma Wilkie, CFA",
        title: "Strategy & Value Creation",
        bio: "CFO at Augur VC, an Energy AI x Data Centers venture fund. Former Investment Banking Associate at CIBC Capital Markets focused on cleantech and cross-sector decarbonization. Previously SVP at Enverus and VP at RS Energy Group, spanning 9+ years across energy research, software, and capital markets. P.Eng. and CFA charterholder with a B.A.Sc. in Mechanical Engineering from Queen's University (Dean's Scholar).",
        imagePlaceholder: "Oma",
        id: "oma",
        category: "partner",
        isHidden: false,
        linkedin: "https://www.linkedin.com/in/omawilkie/"
    },
    {
        name: "Daisy Garcia",
        title: "Investments & M&A",
        bio: "Senior Associate at Prosperity7 Ventures with investments in AI, data infrastructure, cloud, and cybersecurity. Prior investment roles at JetBlue Ventures. Board observer and investor across companies including Snorkel AI, Enfabrica, Opsera, Virtue AI, Cohere, and AppOmni. Thesis work spanning GenAI infrastructure, cloud, DevOps, and data-to-AI pipelines. BA in Applied Mathematics from UC Berkeley.",
        imagePlaceholder: "Daisy",
        id: "daisy",
        category: "partner",
        isHidden: false,
        linkedin: "https://www.linkedin.com/in/daisysg/"
    },
    {
        name: "Kojoh Atta, MBA",
        title: "Investments & M&A",
        bio: "Former Investor at Highland Capital Partners with exposure to Series A and growth-stage software and fintech companies. Experience at TechNexus Venture Collaborative, Spring Point Partners, and KKR. Personal angel investments across fintech, health, and software including early exposure to high-growth companies. Advisor at Golden Palm, a venture platform investing in African fintech and digital infrastructure. BA from Stanford University, MBA from Wharton.",
        imagePlaceholder: "Kojoh",
        id: "kojoh",
        category: "partner",
        isHidden: false,
        linkedin: "https://www.linkedin.com/in/kojoh-atta/"
    },
    {
        name: "Alfredo Diaz, MFin, MEng",
        title: "Managing Partner & CIO",
        bio: "Former Software Engineer & Product Designer. Previously founded and grew multisided marketplace startups catering to freelancers and SMEs. Holds a MEng in Computer Science & Interaction Design from San Francisco State University and a MFin & BBA in Finance from Hult International Business School.",
        imagePlaceholder: "Alfredo",
        id: "alfredo",
        category: "partner",
        linkedin: "https://www.linkedin.com/in/alfredodiaz1/"
    }
];

export const advisors = [
    { name: "Ker Lee Yap", expertise: "Current: GP at Mission Street Capital. Former Software Engineer, ex-Uber ex-Intuit. ", id: "ker-lee", category: "advisor" },
    { name: "Avi Konduru", expertise: "Current: YC Founder. Former Software Engineer, exited fintech founder. ", id: "avi", category: "advisor" }
];

const allMembers: { name: string, role: string }[] = [
    ...teamMembers.map(m => ({ name: m.name, role: m.title })),
    ...advisors.map(a => ({ name: a.name, role: a.expertise }))
];

export const getAuthorRole = (authorName: string) => {
    if (authorName === "Anonymously Generated") {
        return "Internal Ai friend";
    }
    const member = allMembers.find(m => m.name === authorName);
    return member ? member.role : "Investment Partner";
}; 